import React from 'react'

const Checkbox = () => {
    return (
        <div>Checkbox</div>
    )
}

export default Checkbox